module.exports = __webpack_public_path__ + "img/delete_Image_af.b0aa7c0e.svg";